import { render, staticRenderFns } from "./ProjectRecord.vue?vue&type=template&id=00426921&scoped=true"
import script from "./ProjectRecord.vue?vue&type=script&lang=js"
export * from "./ProjectRecord.vue?vue&type=script&lang=js"
import style0 from "./ProjectRecord.vue?vue&type=style&index=0&id=00426921&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00426921",
  null
  
)

export default component.exports